// src/components/questioncompletiondialog/styled.components.ts
import styled from "@emotion/styled";
import { IconButton, Typography } from "@mui/material";
import { mediumMobile, mobile } from "commons/styled.components";

export const DialogContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem;
  background: #fcfcfc;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
  border-radius: 0.625rem;
  position: relative;

  ${mobile(`
    padding: 2rem 1.5rem;
  `)}

  ${mediumMobile(`
    padding: 1.5rem 1rem;
  `)}
`;

export const DialogCloseButton = styled(IconButton)`
  height: 1.5rem;
  width: 1.5rem;
  position: absolute;
  top: 0.625rem;
  right: 0.625rem;
`;

export const HeadingText = styled(Typography)`
  /* You did it! */
  font-weight: 400;
  font-size: 1.3rem;
  color: #000000;
  text-align: center;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  ${mobile(`
    font-size: 1.75rem;
  `)}

  ${mediumMobile(`
    font-size: 1.5rem;
  `)}
`;

export const ClappingIcons = styled.img`
  height: 24px;
  width: 24px;
`;

export const SubheadingText = styled(Typography)`
  /* You’ve completed 10 questions */
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #afafaf;
  text-align: center;
`;

export const ImageContainer = styled.div`
  width: 6.2rem;
  height: 6.2rem;

  ${mediumMobile(`
    width: 5rem;
    height: 5rem;
  `)}

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const CoinsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 1rem 0;

  ${mediumMobile(`
    margin: 0.75rem 0;
  `)}
`;

export const CoinsText = styled(Typography)`
  /* You’ve earned 2 Coins */

  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #000000;
  display: flex;
  align-items: center;
  gap: 0.3rem;
`;

export const HighlightedCoins = styled(Typography)`
  color: #158a73;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 2rem;
  margin-top: 1rem;

  ${mobile(`
    gap: 1rem;
  `)}

  ${mediumMobile(`
    flex-direction: column;
    gap: 0.75rem;
  `)}
`;
